export const initProductVariationSelects = () => {
    const metadata = document.getElementById('refresh-purchase-button-data');
    if (!metadata) {
        return;
    }
    const url = metadata.dataset.url;
    const productId = metadata.dataset.productId;
    const selects = document.querySelectorAll('select[name*="variation"]');
    const selectedValues = {};
    for (const select of selects) {
        const parameterId = select.dataset.parameterId;

        selectedValues[parameterId] = select.value ? parseInt(select.value) : null;

        select.addEventListener('change', (event) => {
            const id = event.target.value ? parseInt(event.target.value) : null;
            const parameterId = event.target.dataset.parameterId;
            selectedValues[parameterId] = id;

            // ověříme, zda jsou vybrané všechny OSTATNÍ selectboxy s hodnotami, pokud ne, neposíláme request
            // pokud ano, znamená to, že jsme právě zvolili variantu, nebo zrušili její zvolení
            // const isOtherParametersSelected = Object.keys(selectedValues)
            //     .filter((key) => key !== parameterId)
            //     .map((key) => selectedValues[key])
            //     .every((value) => value !== null);
            //
            // if (!isOtherParametersSelected) {
            //     return;
            // }

            naja.makeRequest(
                'POST',
                url,
                {
                    parameterToOption: selectedValues,
                    productId,
                },
                { history: false }
            );
        });
    }
};
